import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useImmer } from "use-immer";

import {
  GraphConfig,
  GraphType,
} from "@intelligems/ig-types/schemas/analytics/custom-graphs";
import { useGetSitewideAnalytics } from "@src/api/analytics/get-sitewide-analytics";
import { useGetTinybirdExperienceAnalysis } from "@src/api/analytics/get-tinybird-experience-analysis";
import { selectedExperience } from "@src/store/slices/experiences";

const placeholderGraphConfig: GraphConfig = {
  title: ["Countries"],
  metrics: [],
  dataTypes: ["none"],
  datasetId: "experience_countries",
  graphType: GraphType.Bar,
};

export const useGetAnalyticsCountries = (): string[] => {
  const experience = useSelector(selectedExperience);
  const data = useGetTinybirdExperienceAnalysis(
    {
      experience,
      graphConfigs: [placeholderGraphConfig],
      overviewDataLoaded: true,
    },
    "experiences"
  );

  const [result, setResult] = useImmer<string[]>([]);

  useEffect(() => {
    if (data && data[0]?.isSuccess && result.length === 0) {
      setResult(
        data[0].data.metrics
          .map((metric) => metric["country_code"])
          .filter((data) => data !== "")
      );
    }
  }, [data[0]?.isSuccess, data[0]?.data]);
  return result;
};

export const useGetSitewideAnalyticsCountries = () => {
  const data = useGetSitewideAnalytics("country_codes");
  const [result, setResult] = useImmer<string[]>([]);
  useEffect(() => {
    if (data && data?.isSuccess && result.length === 0) {
      setResult(
        data.data.data
          .map((metric) => metric["country_code"])
          .filter((data) => data !== "")
      );
    }
  }, [data?.isSuccess, data?.data]);
  return result;
};
